<template>
  <form @submit.prevent="save" @keydown="form.onKeydown($event)">
    <div class="row">
      <label for="title" class="col-3 col-form-label text-md-right">{{ $t('title') }}</label>
      <div class="col-7">
        <input id="title" v-model="form.title" type="text" class="form-control">
        <form-error :form="form" field="title"/>
      </div>
    </div>
  </form>
</template>

<script>
import axios from 'axios'
import Form from 'vform'
import { mapGetters } from 'vuex'

export default {
  name: 'AddThirdPartiesTypesForm',

  computed: mapGetters({
    organizations: 'organizations/organizations',
    user: 'auth/user'
  }),

  data: () => ({
    form: new Form({
      title: '',
      organization_id: null
    })
  }),

  methods: {
    isAdmin (user) {
      return isAdmin(user)
    },

    async save () {
      this.$emit('saving')

      this.form.organization_id = this.user.organization_id
      const { data } = await this.form.post('/api/organizations/' + this.user.organization_id + '/thirdpartiestypes')
        .catch((error) => this.$emit('failed'))

      if (!this.form.errors.has('title')) {
        this.$emit('saved', data)
        this.form.reset()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/components/AddThirdPartiesTypesForm.vue